module.exports = __webpack_public_path__ + "static/media/neural-network.1bb15aca.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/ai/icons/neural-network.gif
// module id = 3776
// module chunks = 0